import { css } from "styled-components";
import { CTA } from "../../../../components/CTA";
export const mediaPromoSizes = {
    minHeightDesktop: "640px",
    minHeightTablet: "440px",
    minHeightMobileImage: "600px",
    minHeightMobileNoImage: "440px",
};
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.bottomLarge};
    display: flex;
    min-height: ${mediaPromoSizes.minHeightDesktop};

    ${chroma.mediaQueries.tabletDown} {
      min-height: ${mediaPromoSizes.minHeightTablet};
    }

    ${chroma.mediaQueries.mobileDown} {
      min-height: ${mediaPromoSizes.minHeightMobileImage};
    }
  }

  &:not(.backdrop-exist) {
    background-color: ${paletteTokens.bladebg1};
  }

  &:is(.backdrop-exist) {
    background-color: transparent;
  }

  &:not(.layout-no-image) {
    ${chroma.mediaQueries.mobileDown} {
      min-height: ${mediaPromoSizes.minHeightMobileImage};
    }
  }

  &:is(.layout-no-image) {
    ${chroma.mediaQueries.mobileDown} {
      min-height: ${mediaPromoSizes.minHeightMobileNoImage};
    }
  }

  .blade-content {
    align-self: center;
  }

  .content-no-image {
    ${chroma.mediaQueries.mobileDown} {
      align-self: flex-end;
    }
  }

  .main-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${chroma.spacers.variable.xl};

    ${chroma.mediaQueries.mobileDown} {
      flex-direction: column;
    }
  }

  .wo-image {
    ${chroma.mediaQueries.mobileDown} {
      justify-content: flex-end;
      align-items: flex-start;
    }
  }

  .left-container {
    flex: 0 1 50%;
    max-width: 50%;
    min-height: 100%;

    ${chroma.mediaQueries.mobileDown} {
      max-width: 100%;
    }
  }

  .right-container {
    flex: 0 1 50%;
    max-width: 50%;
    min-height: 100%;

    ${chroma.mediaQueries.mobileDown} {
      min-width: 100%;
    }
  }

  .mediaFirstImpactLarge,
  .mediaFirstImpactSmall {
    ${chroma.mediaQueries.mobileDown} {
      flex-direction: column-reverse;
    }
  }

  .supertitle {
    ${chroma.typography.display7};
    padding-bottom: ${chroma.spacers.variable.xs};
  }

  .title {
    overflow-wrap: break-word;
    ${chroma.typography.display2};
    padding-bottom: ${chroma.spacers.variable.sm};
  }

  .mediaFirstImpactSmall .title,
  .mediaLastImpactSmall .title {
    ${chroma.typography.display4};
  }

  .subtitle {
    ${chroma.typography.body3};
    font-weight: 500;
    padding-bottom: ${chroma.spacers.variable.xs};
  }

  .description {
    ${chroma.typography.body3};
    font-weight: normal;
  }

  .links {
    display: flex;
    align-items: center;
    gap: ${chroma.spacers.constant.s};
    margin-top: ${chroma.spacers.variable.xl};

    ${chroma.mediaQueries.mobileDown} {
      flex-direction: column;
      gap: ${chroma.spacers.variable.xl};

      & > ${CTA} {
        flex: 1;
        width: 100%;

        & .cta-content {
          justify-content: center;
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map